<template>
  <div class="gallery-section" :class="[hasTitle ? 'mt-8 mt-md-10' : 'mt-6']">
    <TitleWidget v-if="hasTitle" :align="align" class="mb-6">
      {{ title }}
    </TitleWidget>

    <v-simple-table>
      <template v-slot:default>
        <tbody>
          <tr
            @click="openWindow(server + path)"
            v-for="({ path, title }, keyItems) in items"
            :key="keyItems"
            class="cursor-pointer attachment"
          >
            <td>
              <div class="d-flex">
                <v-icon size="18" left>
                  {{ selectIcon(path) }}
                </v-icon>

                <div class="text-body-2 text-sm-body-1 attachment-title">
                  {{ title }}
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
  </div>
</template>

<script>
import TitleWidget from "../widgets/TitleWidget.vue";

const _data = {
  title: "Arquivos",
};

export default {
  props: {
    items: {
      type: Array, // { src }[]
      default: () => [],
    },
    hasTitle: {
      type: Boolean,
      default: false,
    },
    align: {
      type: String,
      default: "center",
    },
  },
  data: () => ({
    ..._data,
  }),
  methods: {
    openWindow(v) {
      window.open(v, "_blank");
    },
    selectIcon(v) {
      const ext = v.split(".").pop();
      switch (ext) {
        case "pdf":
          return "fas fa-file-pdf";
        case "doc":
        case "docx":
          return "fas fa-file-word";
        case "ppt":
        case "pptx":
          return "fas fa-file-powerpoint";
        case "csv":
        case "xls":
        case "xlsx":
          return "fas fa-file-excel";
        case "zip":
        case "rar":
          return "fas fa-file-archive";
        default:
          return "fas fa-file-download";
      }
    },
  },
  components: {
    TitleWidget,
  },
};
</script>

<style lang="scss" scoped>
.attachment::v-deep {
  .v-icon,
  .attachment-title {
    color: var(--v-grey-base) !important;
  }

  .attachment-title {
    font-weight: 500 !important;
  }

  &:hover {
    .v-icon,
    .attachment-title {
      color: var(--v-primary-base) !important;
    }
  }
}
</style>
